export const formatAge = (v) => {
    const map = {
        under_18: "Under 18",
        "18_24": "18 - 24",
        "25_29": "25 - 29",
        "30_34": "30 - 34",
        "35_44": "35 - 44",
        "45_55": "45 - 55",
        "55_plus": "55+",
        prefer_not_to_say: "Prefer not to say",
    }
    return map[v] || "";
}

export const formatGender = (v) => {
    const map = {
        male: "Male",
        female: "Female",
        non_binary: "Non-binary",
        other: "Other",
        prefer_not_to_say: "Prefer not to say",
    };
    return map[v] || "";
}

export const formatDescription = (v) => {
    const map = {
        student: "Student",
        working_professional: "Working Professional",
        executive_leadership: "Executive / Leadership",
        caregiver_parent: "Caregiver / Parent",
        entrepreneur: "Entrepreneur",
        retired: "Retired",
        athlete: "Athlete",
        prefer_not_to_say: "Prefer not to say",
    };
    return map[v] || "";
}